<template>
    <div class="help">
        <Bar title="帮助/反馈" @goBack="goBack">
            <template v-slot:right>
                <div class="link-list" @click="handleToFeedbackList">反馈列表<span v-if="messageCount != 0" :class="{long: messageCount.length>1}">{{messageCount}}</span></div>
            </template>
        </Bar>
        <div class="help-body">
            <div v-for="(item) in items" :key="item.id" class="help-item" @click="handleToDetail(item)">
                <img class="help-item__icon" src="@/assets/vipCoach/v2/icon_wttb@2x.png">
                <div class="help-item__title">
                    {{item.title}}
                </div>
                <img class="help-item__arrow" src="@/assets/vipCoach/v2/icon_xyy.png" />
            </div>
        </div>
        <div class="help-footer">
            <van-button class="custom-btn" color="#00CA84" round block @click="handleToFeedback">我要反馈</van-button>
        </div>
    </div>
</template>
<script>
import Bar from '../components/bar.vue'
import { bindAppFn } from '../../utils'
import { Button } from 'vant'
export default {
    name: 'vipCoachHelp',
    components: {
        Bar,
        [Button.name]: Button
    },
    data () {
        return {
            items: [],
            // 反馈列表 提醒数量
            messageCount: '0'
        }
    },
    methods: {
        // 返回上一页
        goBack () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'exitH5'
                }
            })
        },
        // 唤起
        handleToFeedback () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'goFeedback'
                }
            })
        },
        // 唤起
        handleToFeedbackList () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'goFeedbackList'
                }
            })
        },
        // 获取帮助列表信息
        getData () {
            this.$api.getCoachHelpItems().then(res => {
                if (res.status) {
                    this.items = res.result
                }
            })
        },
        // 进入详情
        handleToDetail ({ id }) {
            this.$router.push({
                name: 'vipCoachHelpDetail',
                query: {
                    id
                }
            })
        },
        // 获取APP凭证
        getToken () {
            return new Promise((resolve) => {
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'getCtlToken'
                    },
                    currentFnName: 'getCoachAppCtlToken',
                    callback: (e) => {
                        let token = ''
                        if (e && e !== 'null') {
                            try {
                                // andorid 处理方式
                                token = Object.values(JSON.parse(e))[0]
                            } catch (error) {
                                // ios处理方式
                                token = e
                            }
                        }
                        localStorage.setItem('ctl-token', token)
                        resolve(e)
                    }
                })
            })
        },
        // 获取教练端反馈信息的数量
        getFeedbackCount(){
            return this.$api.getCoachFeedbackCount().then(res => {
                if (res.status) {
                    // 获取反馈总数 当超过99的时候 后端那边是返回99+
                    this.messageCount = res.result.count
                }
            })
        }
    },
    async mounted () {
        this.getData()
        await this.getToken()
        await this.getFeedbackCount()
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
.help{
    display: flex;
    flex-direction: column;
    padding: 0 15px;
    height: 100vh;
    background-color: #F3F4FB;
    &-body{
        margin-top: 10px;
        flex: 1;
        padding: 15px;
        background: #fff;
        border-radius: 5px;
        height: 0;
        overflow: auto;
        -webkit-overflow-scrolling: touch;   //该属性随着手指离开还会保持滚动
        overflow-scrolling: touch;
    }
    &-footer{
        margin-top: 15px;
        padding:7px 0;
    }
    &-item{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #EBECF4;
        &:last-child{
            border-bottom: 0;
        }
        &__icon {
            margin-right: 10px;
            width: 18px;
            height: 18px;
        }
        &__title{
            color:#333;
            flex: 1;
            font-size: 15px;
            font-weight: 400;
        }
        &__arrow{
            width: 14px;
        }
    }
    .custom-btn{
        font-size: 16px;
        height: 46px;
    }
    .link-list{
        position: absolute;
        top: 50%;
        right: 15px;
        color:#594F60;
        font-size: 14px;
        transform: translateY(-50%);
        span {
            position: absolute;
            bottom: 12px;
            right: 0;
            width: 16px;
            height: 16px;
            color:#fff;
            font-size: 12px;
            background-color: #FE4A48;
            border-radius: 50%;
            text-align: center;
            &.long{
                width: unset;
                padding: 0 5px;
                border-radius: 8px;
            }
        }
    }
}
</style>
